import React, { useEffect } from 'react'
import Loader from './Loader/Loader'
import { useNavigate } from 'react-router-dom'

const NavigateComponent = () => {

    const navigate = useNavigate()

    useEffect(() => {
        navigate('/patient-demo-login');
    }, []);

    return (
        <Loader />
    )
}

export default NavigateComponent